import request from '@/router/axios';

export const getList = (current, size, params) => request({
  url: '/api/blade-system/param/list',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})
export const remove = ids => request({
  url: '/api/blade-system/param/remove',
  method: 'post',
  params: {
    ids,
  },
})

export const add = row => request({
  url: '/api/blade-system/param/submit',
  method: 'post',
  data: row,
})

export const update = row => request({
  url: '/api/blade-system/param/submit',
  method: 'post',
  data: row,
})
